import ACTIONS from './RouterActions';

const initialState = {
  link: ''
};

/**
 * Reducer to store and remove redirect url 
 * set via middleware. 
 * setRouterLink('/home') to url 
 * setRouterLink(-1) back one page
 */
const routerReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.Types.SET_ROUTER_LINK: { 
            return { ...state, ...action.payload}
        }
        case ACTIONS.Types.REMOVE_ROUTER_LINK: {
            return { ...state, ...initialState}
        }

        default: {
            return {
                ...state
            }
        }
    }
};

export default routerReducer;
